import { render } from "./previewImg.vue?vue&type=template&id=1d57c08a&scoped=true"
import script from "./previewImg.vue?vue&type=script&lang=js"
export * from "./previewImg.vue?vue&type=script&lang=js"

import "./previewImg.vue?vue&type=style&index=0&id=1d57c08a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1d57c08a"

export default script